<template>
  <v-modal short @close="handleClose">
    <template :slot="STAGES.REQUEST">
      <div class="auth-modal__content pt-2">
        <div>
          <h2 class="mt-1 mb-2">Receive Notifications On This Device</h2>
          <p class="mb-3 mt-0">
            We’ll notify you about special updates, messages & upcoming events
          </p>
          <v-button :is-loading="isLoading" block @click="askForPermissions">
            Yes, notify me
          </v-button>
          <v-button block class="mt-2" ghost @click="closeModal">
            Maybe Later
          </v-button>
        </div>
      </div>
    </template>
    <template :slot="STAGES.GRANTED">
      <div class="text-center px-2 pt-4">
        <v-icon size="3rem" icon="alarm_on"></v-icon>
        <h2 class="my-2">Successfully Enabled</h2>
        <p class="my-0">
          You will now receive notifications on this device
        </p>
        <v-button block secondary class="mt-3" @click="closeModal">
          Dismiss
        </v-button>
      </div>
    </template>
    <template :slot="STAGES.DENIED">
      <div class="text-center px-2 pt-4">
        <v-icon size="3rem" icon="notifications_off"></v-icon>
        <h2 class="my-2">Enable Notifications</h2>
        <p>
          You may need to enable notifications from your device or browser
          settings
        </p>
        <v-button v-if="isNativePush" primary block @click="openSettings">
          Open Settings
        </v-button>
      </div>
    </template>
  </v-modal>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex"

import { WINDOW_EVENTS } from "@shared/admin-app-constants"

import EventBus, { EVENTS } from "@/lib/event-bus"
import {
  initializePushNotifications,
  requestPermission,
  isNativePush,
  openSettings,
  queryPushStatus
} from "@/lib/push-notification"
import isPreviewContext from "@/lib/is-platform/is-preview-context"

export const STAGES = {
  REQUEST: "#notifications",
  GRANTED: "#notifications/granted",
  DENIED: "#notifications/denied"
}

export default {
  data() {
    return {
      isGranted: false,
      isDenied: false,
      showModal: false,
      isLoading: false,
      isNativePush,
      STAGES
    }
  },

  computed: {
    ...mapState("notifications", ["canAsk"]),
    ...mapGetters("notifications", ["shouldAskForPermission", "isPushEnabled"]),

    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters(["app"])
  },

  mounted() {
    EventBus.$on(EVENTS.PROMPT_PUSH_PERMISSION, () => {
      if (this.shouldAskForPermission) {
        if (isPreviewContext()) {
          const { postMessage } = require("@/lib/admin-iframe-helpers")

          postMessage(WINDOW_EVENTS.PROMPT_PUSH_PERMISSION)
        } else {
          queryPushStatus().then(() => {
            if (!this.isPushEnabled()) {
              this.$router.push(STAGES.REQUEST)
            }
          })
        }
      }
    })
  },

  methods: {
    ...mapMutations("notifications", ["setToken", "setLastAskedForPermission"]),

    closeModal() {
      this.$router.removeHash()
      this.handleClose()
    },

    handleClose() {
      this.setLastAskedForPermission()
      this.showModal = false
      this.isDenied = false
      this.isGranted = false
      this.isLoading = false
    },

    askForPermissions() {
      this.isLoading = true

      requestPermission()
        .then(() => {
          this.$router.push(STAGES.GRANTED)
          this.isGranted = true
        })
        .catch(() => {
          this.$router.push(STAGES.DENIED)
          this.isDenied = true
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    openSettings() {
      openSettings()
      this.closeModal()
    }
  },

  watch: {
    isAuthenticated: {
      immediate: true,
      handler: function() {
        if (this.isAuthenticated) {
          initializePushNotifications()
        }
      }
    }
  }
}
</script>
